import {
  SET_MARKETING_COMMUNICATIONS_CONSENTS,
  SET_MARKETING_COMMUNICATIONS_PREFERENCE,
} from '../actions/preferences/marketingCommunications';
import { SET_CALENDAR_EVENTS_PREFERENCES } from '../actions/preferences/calendarEvents';
import { SET_SKIP_HEALTHIFY_PREFERENCE } from '../actions/preferences/calorieSaver';
import {
  setMarketingCommunicationsConsents,
  setMarketingCommunicationsPreference,
} from './preferences/settingsMarketingCommunicationsActions';

export const settingsPreferencesActions = {
  /* Marketing Communications */
  [SET_MARKETING_COMMUNICATIONS_PREFERENCE]: setMarketingCommunicationsPreference,
  [SET_MARKETING_COMMUNICATIONS_CONSENTS]: setMarketingCommunicationsConsents,
  /* Calendar Reminders */
  [SET_CALENDAR_EVENTS_PREFERENCES]: ({ state, action }) => ({
    ...state,
    calendarAttachmentsEnabled: action.calendarAttachmentsEnabled,
  }),
  /* Calorie Saver */
  [SET_SKIP_HEALTHIFY_PREFERENCE]: ({ state, action }) => ({ ...state, skipHealthify: action.skipHealthify }),
  /* Export Favourites */
};
